import { render } from "./userInfoForm.vue?vue&type=template&id=17681120&scoped=true"
import script from "./userInfoForm.vue?vue&type=script&lang=js"
export * from "./userInfoForm.vue?vue&type=script&lang=js"

import "./userInfoForm.vue?vue&type=style&index=0&id=17681120&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17681120"]])

export default __exports__